import './bannerImage.css';
import BannerImageFile from '../../assets/banner-image.png'
const BannerImage = ({ text}) => {
    return (
        <div className="banner-image-wrapper">
            {/* <img src={BannerImageFile} alt="GovEx banner image" className="banner-image__img" /> */}
           <div className='banner-image__overlay'>
                <h1 className='banner-image__text'>{text}</h1>  
                </div>
        </div>
    );
};

export default BannerImage;